import axios from 'axios'
import {ResponseObject} from '../../../models'
import {
  CensoFiltroResponse,
  CensusFilterModel,
  CensusHistoryModel,
  CensusHistoryResponse,
  CensusSaveModel,
  SummaryModel,
} from '../model/census.model'
const BASEURL = process.env.REACT_APP_DEV_API_LIMPIEZA_URL

export const CENSUS_SERVICES = {
  filterCensus: async (dto: CensusFilterModel) => {
    return await axios.post<ResponseObject<CensoFiltroResponse[]>>(`${BASEURL}/censo/filtro`, dto)
  },
  saveCensus: async (dto: CensusSaveModel) => {
    return await axios.post<ResponseObject<string>>(`${BASEURL}/censo/guardar`, dto)
  },
  resumenCensus: async (dto: string) => {
    return await axios.get<ResponseObject<SummaryModel>>(
      `${BASEURL}/censo/resumen?censoCabeceraId=${dto}`,
    )
  },
  reportCensus: async (dto: CensusHistoryModel) => {
    return await axios.post<ResponseObject<CensusHistoryResponse[]>>(
      `${BASEURL}/censo/reporte`,
      dto,
    )
  },
  reportExcelCensus(dto: CensusHistoryModel) {
    return axios.post(`${BASEURL}/censo/reporteExcel`, dto, {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      },
      responseType: 'arraybuffer',
    })
  }
}
